<template>
    <div class="toolbar navigation-bar" :class="hasRightGroup ? 'with-right-group' : 'without-right-group'">
        <div class="wbtn-array topbar-labels" style="grid-column: 1">
            <slot name="main-group"> </slot>
        </div>
        <div v-if="hasRightGroup" class="wbtn-array bottom-bar" style="grid-column: 3">
            <slot name="right-group"> </slot>
        </div>
    </div>
</template>

<script lang="ts">
require("@/assets/portal.css");
import { defineComponent } from "vue";

export default defineComponent({
    computed: {
        hasRightGroup(): boolean {
            return Boolean(this.$slots["right-group"]);
        },
    },
});
</script>

<style scoped>
.toolbar.with-right-group {
    height: 80px;
}

.toolbar.without-right-group {
    height: 40px;
}

.navigation-bar {
    display: flex;
    flex-direction: column;
    background-color: var(--background-toolbar);
}

.toolbar.with-right-group .topbar-labels {
    border-bottom: 1px solid var(--thin-border);
}

.topbar-labels {
    height: 40px;
}

.bottom-bar {
    justify-content: flex-end !important;
    padding: 8px 16px;
}

.wbtn-array {
    display: flex;
    justify-content: normal;
    align-items: stretch;
    white-space: nowrap;
}

.wbtn-array.right-aligned {
    margin-left: auto;
    margin-right: 12px;
}

.wbtn-array .wbtn {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-left: 0px;
    padding-right: 10px;
    box-sizing: content-box;
}
</style>
